(ns app.front.ui.yes-no-radio-buttons
  (:require [core.front.carbon :as cc]
            [potpuri.core :as p]))

(defn yes-no-radio-buttons
  "Make a group of two radio buttons for yes/no - settings.

  Arguments [optional]:
  `tr`    i18n translation function
  `id`    the id/name to be used to refer to this component/subcomponents
  `opts`  a map of (extended) `cc/radio-button-group` options;
          most useful of these are :value-selected and :on-change.
          Note that unlike `cc/radio-button-group`, here :value-selected will accept only a boolean or nil.
          Also unlike `cc/radio-button-group` :disabled disables all radio buttons in the group.

          Also allows the following optional keys:
            [:tr-yes]     localization key for 'yes' label  (default :yes)
            [:tr-no]      localization key for 'no' label   (default :no)
            [:label-yes]  translated string label for 'yes' (overrides :tr-yes)
            [:label-no]   translated string label for 'no'  (overrides :tr-no)"
  [tr id {:keys [tr-yes tr-no label-yes label-no disabled] :as opts}]
  (let [yes-id (str id "-yes")
        no-id  (str id "-no")]
    (cc/radio-button-group
      (merge (p/assoc-if {:name id}
                         :value-selected (case (:value-selected opts)
                                           true  "yes"
                                           false "no"
                                           nil   nil)
                         :on-change      (when-let [on-change (:on-change opts)]
                                           #(on-change (= "yes" %))))
             (dissoc opts :tr-yes :tr-no :label-yes :label-no :value-selected :on-change))
      (cc/radio-button {:id         yes-id
                        :name       yes-id
                        :disabled   (boolean disabled)
                        :label-text (or label-yes (tr [(or tr-yes :yes)]))
                        :value      "yes"})
      (cc/radio-button {:id         no-id
                        :name       no-id
                        :disabled   (boolean disabled)
                        :label-text (or label-no (tr [(or tr-no :no)]))
                        :value      "no"}))))
